{
  "super_admin": "Super admin",
  "ops_manager": "Operations manager",
  "operator": "Operator",
  "account_manager": "Account manager",
  "developer": "Developer",
  "auditor": "Auditor",
  "service_account": "Service account"
}
